export default __webpack_public_path__ + "static/media/photo--lg--140.867c264b.jpg";